import React from 'react';
import {getAccount, getAtpDetails,getCardCustomerId} from "../cardHelper";
import styles from './IncomeHousingSettings.scss';
import CSSModules from 'react-css-modules';
import moment from "moment";
import MoneyInput from '../../components/common/Input/MoneyInput';
import Dropdown from '../../components/common/material/DropDown';
import RaisedButton from "../../components/common/material/RaisedButton";
import Button from "../../components/common/material/Button";
import {connect} from "react-redux";
import * as cardActions from "../redux";
import {ACTION_STATUS_PENDING} from "../../utils/redux/thunkActionConstants";
import LoadingBlocking from "/components/loading/LoadingBlocking";
import UpdateSuccessDialog, {ATPSuccessActions} from "../CardDialogs/UpdateSuccessModal/UpdateSuccessDialog";
import ErrorDialog from '../CardDialogs/ErrorDialog/ErrorDialog';
import SalaryOutOfRangeDialog from "../CardDialogs/SalaryOutOfRangeDialog/SalaryOutOfRangeDialog";
import * as thunkActionHelpers from "utils/redux/thunkActionHelpers";
import IncomeInfoModal from "../CardDialogs/IncomeInfoDialog/IncomeInfoModal";
import {replace} from "react-router-redux";
import {FormattedMessage} from "react-intl";
import {datadogRum} from "@datadog/browser-rum";
import {MixPanelEvents,MixPanelAtpSteps} from "../../constants/mixpanel";
import { trackEvent } from "../../reducers/analyticsReducer";

const LOW_MONTHLY_INCOME_LINE = 3500;
const HIGH_MONTHLY_INCOME_LINE = 25000;
const MAX_OUT_OF_RANGE_INCOME_TRYES = 1;

const defaultMsgErrorKey = 'card.settings.error.UpdateError';


// for monitoring- if user switch to another window a we blur all focus since it
// will auto focus where user return to window
window.addEventListener( 'blur',() => {
  const handleBlur = () => document.activeElement.blur();
  handleBlur();
  window.removeEventListener('blur', handleBlur);
});

const housingTypes = [
  { label: 'Own', value: 'OWN' },
  { label: 'Live with family', value: 'FAMILY' },
  { label: 'Rent', value: 'RENT' },
  ];

@connect(state => ({
  card: state.card,
  messages: state.i18n.messages,
  routeParams:state.routing.locationBeforeTransitions.query

  }),
  dispatch =>({
    getCardAccount: () => dispatch(cardActions.fetch()),
    redirect: path => dispatch(replace(path)),
    updateAtp: (atpDetails) => dispatch(cardActions.setIncomeAndExpenses(atpDetails)),
    fetchAtpDetails: () => dispatch(cardActions.fetchAtpDetails()),
    trackEvent: (eventName, properties) => dispatch(trackEvent(eventName, properties))
  })
)
@CSSModules(styles, {allowMultiple: true})
class IncomeHousingSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values:{
        expenses: null,
        income: null,
        housingType: '',
      },
      submissionTime : null,
      isShowSuccessModal: false,
      isShowInfoModal: false,
      isShowIncomeOuOfRangeModal: false,
      isError:false,
      disabled:false,
      isShowOutOfRangeModal: false,
      outOfRangeIncomeTrys : 0
    };

  }

  isActionSuccess(props,action) {
    props = props || this.props;
    return thunkActionHelpers.actionSuccess(
      action,
      props.card.type,
      props.card.status
    );
  }
     componentDidMount() {
      this.handleAtpDetailsPopulate();
    }

  async handleAtpDetailsPopulate() {
    const currentAtpDetails = getAtpDetails(this.props);
// if this data not fetched yet
    if (!currentAtpDetails) {
      if (getAccount(this.props)) {
        await this.props.fetchAtpDetails();
        if (getAtpDetails(this.props)) {
          this.populateAtpValues();
        }
      }
    }
    else {
      this.populateAtpValues();
    }
  }

  isActionFailed(props,action) {
    props = props || this.props;
    return thunkActionHelpers.actionFail(
      action,
      props.card.type,
      props.card.status
    );
  }

  componentDidUpdate(prevProps) {
    //status change indicate a network call has been made and possible updates need to be made
    const isRequestStatusChanged = prevProps.card.status !== this.props.card.status;

    if (isRequestStatusChanged) {
      if (this.isActionFailed(this.props, cardActions.CARD_UPDATE_INCOME_EXPENSES)) {
        this.setState(prevState => ({...prevState, isError: true}));
        datadogRum.addUserAction('Failed to update Atp details', {customerId: getCardCustomerId(this.props)});
      }
      if (this.isActionFailed(this.props, cardActions.CARD_FETCH_INCOME_EXPENSES)) {
        datadogRum.addUserAction('Failed to fetch Atp details', {customerId: getCardCustomerId(this.props)});
      }
      if (this.isActionSuccess(this.props, cardActions.CARD_UPDATE_INCOME_EXPENSES)) {
        this.setState({...this.state, isShowSuccessModal: true});
        this.handleAtpDetailsPopulate();
        this.sendTrackingEvent(MixPanelAtpSteps.atpSubmit, this.state.values);
        datadogRum.addUserAction('Successfully update Atp details', {customerId: getCardCustomerId(this.props)});
      }
      if (this.isActionSuccess(this.props, cardActions.FETCH)) {
        this.handleAtpDetailsPopulate();
      }
    }
  }


  handleOnChange(name, val){
    this.setState((prevState) => {
      const newValues = {...prevState.values, [name] : val};
      return {...prevState, values: newValues, disabled : !this.validateInputs(newValues)};
    });
  }
  toggleModal(modalFieldName){
      this.setState((prevState) => ({...this.state, [modalFieldName]: !prevState[modalFieldName]}));
    }


  validateInputs(inputValues = this.state.values){
    return Object.values(inputValues).every(val => Boolean(val));
  }

  handleSubmit(){
    //check if the income entered is less or more then the standard range in order to give warning for the user
    const salaryOutOfRange = this.state.values.income < LOW_MONTHLY_INCOME_LINE || this.state.values.income > HIGH_MONTHLY_INCOME_LINE;
      if(salaryOutOfRange && this.state.outOfRangeIncomeTrys < MAX_OUT_OF_RANGE_INCOME_TRYES){
        this.setState((prevState) => ({...prevState, isShowOutOfRangeModal: true,outOfRangeIncomeTrys : prevState.outOfRangeIncomeTrys + 1 })) ;
      }
      else {
        this.submitAtpUpdate();
      }
  }

  submitAtpUpdate(){
    this.props.updateAtp({
      housingExpenseType: this.state.values.housingType,
      monthlyIncome: this.state.values.income,
      monthlyHousing: this.state.values.expenses
    });
  }

  handleSuccessAction(action){
    switch (action) {
      case  ATPSuccessActions.backToSettings:
        this.setState({...this.state, isShowSuccessModal: false});
        break;
      case  ATPSuccessActions.gotToAccounts:
        this.props.redirect('/card');
        break;
    }
  }

  populateAtpValues(){
    this.setState((prevState) => {
        const values  = {
          income: this.props.card.card.atpDetails.income,
          expenses: this.props.card.card.atpDetails.housing,
          housingType: this.props.card.card.atpDetails.housingExpenseType,
      };
        return {
          ...prevState,values,submissionTime : this.props.card.card.atpDetails.submissionTime
        };
      });
  }

  sendTrackingEvent(step, properties){
    const baseAtpProperties = {...this.props.routeParams , customerId: getCardCustomerId(this.props)};

    this.props.trackEvent( MixPanelEvents.atpUpdate, {...properties,...baseAtpProperties, step});
  }

  handleCancel(){
    this.populateAtpValues();
    this.sendTrackingEvent(MixPanelAtpSteps.atpCancel);
  }

  render() {
    return (
      <div styleName={'incomeHousingSettings'}>
        {this.props.card.status === ACTION_STATUS_PENDING && <LoadingBlocking/> }
      <div styleName={'subtitleInfo'}>
        <span data-at={'atpSubtitle'}>
          <FormattedMessage id={'atpUpdate.subtitle'}/>
        </span>
        {this.state.submissionTime && <div data-at={'lastAtpUpdateDate'}>
          <FormattedMessage id={'atpUpdate.lasUpdate'} values={{lastAtpUpdateDate : moment(this.state.submissionTime).format('MM/DD/YYYY')}}/>
        </div>
        }
      </div>
      <div styleName={'incomeInput atpInput'}>
        <MoneyInput onFocus={() => {
          this.sendTrackingEvent(MixPanelAtpSteps.incomeFieldFocus);
        }} dataAt={'atpIncomeInput'} value={this.state.values.income} onChange={this.handleOnChange.bind(this,'income')} labelId={'atpUpdate.income.label'}/>
        <div data-at="incomeInfoLink" styleName="modalLink" onClick={() => {
          this.toggleModal('isShowInfoModal',true);
          this.sendTrackingEvent(MixPanelAtpSteps.incomeWhatIsButtonClicks);
        }}>
          <FormattedMessage id={'atpUpdate.income.infoLink'}/>
        </div>
      </div>

      <div styleName={'housingContainer'}>
        <div styleName={'dropdownContainer'}>
        <label styleName={'inputLabel'}><FormattedMessage id={'atpUpdate.expenses.HousingType'}/> </label>
          <div styleName={'dropdown'}>
        <Dropdown onClick={() => this.sendTrackingEvent.apply(this,[MixPanelAtpSteps.housingStatusClicks])} theme={{values:styles.dropdownValues}} data-at ="housingStatusDropdown" label={this.state.values.housingType ? '' : this.props.messages['common.select']} onChange={this.handleOnChange.bind(this,'housingType')}
                  value={this.state.values.housingType}
                  styleName={'housingDropdown'}
                  auto={false} source={housingTypes}/>
          </div>
        </div>
        <div styleName="atpInput">
        <MoneyInput onFocus={() => this.sendTrackingEvent(MixPanelAtpSteps.housingExpensesFieldFocus)} dataAt={'atpHousingExpensesInput'} helperTextId={'atpUpdate.expenses.helperText'} value={this.state.values.expenses} onChange={this.handleOnChange.bind(this,'expenses')}
                    labelId={'atpUpdate.expenses.label'}/>
        </div>
        </div>
        <div styleName={'actionGroup'}>
        <RaisedButton disabled={!this.validateInputs()} primary={true} styleName="baseBtn" onClick = {this.handleSubmit.bind(this)} data-at={'submitAtpUpdateBtn'}>
          <FormattedMessage id={'common.update'}/></RaisedButton>
        <Button flat={true} styleName={'baseBtn cancelBtn'} onClick = {this.handleCancel.bind(this)} data-at={'cancelAtpChangesBtn'}>
          <FormattedMessage id={'common.cancel'}/>
        </Button>
        </div>
        <IncomeInfoModal handleAction={this.toggleModal.bind(this,'isShowInfoModal')} isOpen={this.state.isShowInfoModal}/>
        <UpdateSuccessDialog handleAction ={this.handleSuccessAction.bind(this)} active={this.state.isShowSuccessModal}/>
        <ErrorDialog paymentErrorMessageKey ={defaultMsgErrorKey} isOpen={this.state.isError}
                     onClose={() => this.setState((prevState) =>  ({...prevState, isError:false}))} />
        <SalaryOutOfRangeDialog  handleSubmit ={() => {
          this.toggleModal('isShowOutOfRangeModal');
          this.submitAtpUpdate();
        }}    handleClose={() => this.setState({...this.state, isShowOutOfRangeModal : false})} isOpen={this.state.isShowOutOfRangeModal}/>
    </div>
    );
  }

}

IncomeHousingSettings.propTypes = {};

export default IncomeHousingSettings;



// WEBPACK FOOTER //
// ./src/card/IncomeHousingSettings/IncomeHousingSettings.js